import React from 'react';
import { Link, browserHistory } from 'react-router';
import DataTable from 'components/data-table';
import {RowItemDocumentDetail} from 'modules/reception/datatable/detail';
import { connect } from 'react-redux';
import { msg } from "constants/message";
import { Reception } from 'api';
import { header } from "constants/table";
import { Toastr } from 'modules/toastr';
import moment from 'moment';
import {CheckPermission} from 'modules/login/CheckPermission';
import {TextMessage} from 'components/tt-forms/common';
import {
  ThongTinNguoiDungDon,
  ThongTinDonVuViec,
  ThongTinCoQuanDaGiaiQuyet,
  ThongTinNguoiUyQuyen
} from 'modules/letter-information/letter-detail';
import { TinhTrangDon } from 'modules/reception';
import { ShowIf } from 'components/utils';
import {MasterLayout} from 'layout';

class DetailReception extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      ngayTiepNhan: '',

      dsTaiLieuBoSung: [],
      TongLuotTiep: '',

      YeuCauGapLanhDao: false,
      HuongXuLy: '',
      GhiChuXuLy: '',
      LoaiHuongXuLyTCD: '',
      DanhSachHuongXuLy: '',
      DiaDiemGapLanhDao: '',
      NgayHenGapLanhDao: '',
      TenDonThu: '',
      idSoTiepCongDan: '',
      soTiepCongDan: '',
      idDonTCD: '',
      taiLieuBangChungId: '',
      NgayTiepDan: '',
      NoiDungBoSung: '',
      detail: {
        canBoTiepDanInfo: {
          hoVaTen: ''
        },
        coQuanToChucTiepDanSTCD: [],
        donSTCD: {
          listNguoiDungDon: [],
          nguoiDuocUyQuyen: {
            chucVu: '',
            diaChiCoQuan: '',
            luatSu: '',
            ngayCapTheLuatSu: '',
            noiCapTheLuatSu: '',
            phanLoaiCongDan: '',
            soTheLuatSu: '',
            tenCoQuan: '',
            coUyQuyen: false,
            danTocCongDan: {
              ten: ''
            },
            diaChi: '',
            gioiTinh: true,
            hoVaTen: '',
            ngayCap: '',
            ngaySinh: '',
            noiCapCMNDInfo: {
              ten: ''
            },
            phuongXaCongDan: {
              ten: ''
            },
            quanHuyenCongDan: {
              ten: ''
            },
            quocTichCongDan: {
              ten: ''
            },
            soCMNDHoChieu: '',
            soDienThoai: '',
            tinhThanhCongDan: {
              ten: ''
            },
            toThon: ''
          },
          listTaiLieuBangChung: [],
          listTaiLieuBangChungLuatSu: [],
          loaiDon: '',
          loaiDoiTuong: '',
          loaiNguoiDungDon: '',
          linhVucDonThuDon: {
            ten: ''
          },
          linhVucDonThuChiTietDon: {
            ten: ''
          },
          chiTietLinhVucDonThuChiTietDon: {
            ten: ''
          },
          noiDung: '',
          coQuanDaGiaiQuyetDon: {
            ten: '',
            capCoQuanQuanLyInfo: {
              ten: '',
            }
          },
          thamQuyenGiaiQuyetInfo: {
            ten: ''
          },
          lanGiaiQuyet: '',
          hinhThucDaGiaiQuyet: '',
          huongGiaiQuyetDaThucHien: '',
          coThongTinCoQuanDaGiaiQuyet: true,
        },
        taiLieuBangChungBoSungs: [],
        ghiChuXuLy: '',
        huongGiaiQuyetTCDLanhDao: '',
        huongXuLy: '',
        huongXuLyText: '',
        ketQuaGiaiQuyet: '',
        listTaiLieuVanThu: [],
        loaiTiepDan: '',
        ngayTiepDan: new Date(),
        noiDungTiepCongDan: '',
        thoiHan: '',
        trangThaiKetQua: '',
        yKienXuLy: '',
        tableLoading: true,
        loadingSave: false,
      },

      data: {},
      dataNguoiDungDon: [],
      loaiNguoiDungDon: '',
      dataNguoiDuocUyQuyen: {},
      listTepUyQuyen: [],
      listTepChungChiHanhNghe: [],
      loaiDon: '',
      loaiDonGiaTri: '',
      loaiDoiTuong: '',
      linhVuc: '',
      linhVucChiTiet: '',
      linhVucChiTietSub: '',
      listTaiLieuBangChung: [],
      noiDung: '',
      dataCoQuanDaGiaiQuyet: {},
      dataDoanDiCung: [],
      linhVucChiTietKhac: ''
    }
  }

  componentDidMount() {
    this.getCongChucUser(this.state.userInfo.id);
    this.getListDetailReception(this.props.params.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id != this.props.params.id) {
      this.getListDetailReception(nextProps.param.id);
    }
  }

  getCongChucUser(uid) {
    Reception.actions.getCongchucOfUser.request({ id: uid }).then(res => {
      if (res.data) {
        this.state.userInfo.coQuanQuanLyId = res.data.donViCongChuc.coQuanQuanLyId;
      }
    });
  }

  getDonInfo(resData) {
    Reception.actions.getDonInfo.request({ id: resData.donSTCD.donId}).then(res => {
      if (res.data) {
        resData.donSTCD = {...resData.donSTCD, ...res.data};
        this.setState({
          detail: resData,
          listTaiLieuBangChung: [...res.data.listTaiLieuBangChung, ...res.data.listTaiLieuBangChungLuatSu],
          dataDoanDiCung: res.data.listDoanDiCung,
          dataNguoiDuocUyQuyen: res.data.nguoiDuocUyQuyen || [],
          data: resData.donSTCD,
          loaiNguoiDungDon: resData.donSTCD.loaiNguoiDungDon ? resData.donSTCD.loaiNguoiDungDon : '',
          dataNguoiDungDon: resData.donSTCD.listNguoiDungDon ? resData.donSTCD.listNguoiDungDon : [],
          loaiDon: resData.donSTCD.loaiDonText ? resData.donSTCD.loaiDonText : '',
          loaiDonGiaTri: resData.donSTCD.loaiDon ? resData.donSTCD.loaiDon : '',
          loaiDoiTuong: resData.donSTCD.loaiDoiTuongInfo ? resData.donSTCD.loaiDoiTuongInfo : '',
          linhVuc: resData.donSTCD.linhVucDonThuDon ? resData.donSTCD.linhVucDonThuDon.ten : '',
          linhVucChiTiet: (resData.donSTCD.linhVucDonThuDon && resData.donSTCD.linhVucDonThuChiTietDon) ? resData.donSTCD.linhVucDonThuChiTietDon.ten : '',
          linhVucChiTietSub: (resData.donSTCD.linhVucDonThuDon && resData.donSTCD.linhVucDonThuChiTietDon && resData.donSTCD.chiTietLinhVucDonThuChiTietDon) ? resData.donSTCD.chiTietLinhVucDonThuChiTietDon.ten : '',
          noiDung: resData.donSTCD.noiDung ? resData.donSTCD.noiDung : '',
          dataCoQuanDaGiaiQuyet: ((resData.donSTCD.coThongTinCoQuanDaGiaiQuyet && resData.donSTCD.coQuanDaGiaiQuyetDon) ? resData.donSTCD.coQuanDaGiaiQuyetDon : {}),
          idDonTCD: resData.donSTCD.donId,
          idSoTiepCongDan: resData.soTiepCongDanId,
          ngayTiepNhan: resData.ngayTiepDan ? moment(resData.ngayTiepDan).format('DD/MM/YYYY - HH:mm') : '',
          NgayTiepDan: resData.donSTCD.ngayTiepDan ? moment(resData.donSTCD.ngayTiepDan).format('DD/MM/YYYY') : '',
          TongLuotTiep: resData.soLuotTiepStr,
          HuongXuLy: resData.huongXuLy,
          GhiChuXuLy: resData.noiDungTiepCongDan,
          DiaDiemGapLanhDao: resData.diaDiemGapLanhDao,
          YeuCauGapLanhDao: resData.donSTCD.yeuCauGapTrucTiepLanhDao,
          NgayHenGapLanhDao: resData.ngayHenGapLanhDao ? moment(resData.ngayHenGapLanhDao).format('DD/MM/YYYY') : '',
          linhVucChiTietKhac: resData.donSTCD.linhVucChiTietKhac || ''
        });
      }
    });
  }

  getListDetailReception(inputId) {
    Reception.actions.getDetailReception.request({ id: inputId }).then(res => {
      if (res.data) {
        this.getDonInfo(res.data);
      }
    });
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  checkBienBanTCD() {
    let pass = true;
    this.state.listTaiLieuBangChung.map(item => {
      if (item.ten == 'Đơn công dân/Biên bản TCD' && !item.duongDan) {
        pass = false;
      }
    });
    return pass;
  }

  updateDon() {
    if (!this.checkBienBanTCD()) {
      Toastr('Vui lòng đính kèm Đơn công dân/Biên bản TCD trước khi chuyển xử lý đơn', 'warning');
    } else {
      this.setState({ loadingSave: true });
      let params = {
        coUyQuyen: this.state.detail.donSTCD.coUyQuyen,
        coThongTinCoQuanDaGiaiQuyet: this.state.detail.donSTCD.coThongTinCoQuanDaGiaiQuyet,
        noiDung: this.state.detail.donSTCD.noiDung,
        loaiDon: this.state.detail.donSTCD.loaiDon,
        loaiDoiTuong: this.state.detail.donSTCD.loaiDoiTuong,
        loaiVuViec: this.state.detail.donSTCD.loaiVuViec,
        nguonTiepNhanDon: 'TRUC_TIEP',
        loaiNguoiDungDon: this.state.detail.donSTCD.loaiNguoiDungDon,
        linhVucDonThu: { id: this.state.detail.donSTCD.linhVucDonThuDon.linhVucDonThuId },
        thanhLapDon: true,
        canBoXuLy: { id: this.state.detail.canBoTiepDanInfo.congChucId },
        soNguoi: this.state.detail.donSTCD.soNguoi,
        tongSoLuotTCD: this.state.detail.donSTCD.tongSoLuotTCD
      };

      if (this.state.detail.donSTCD.linhVucDonThuChiTietDon) {
        params.linhVucDonThuChiTiet = { id: this.state.detail.donSTCD.linhVucDonThuChiTietDon.linhVucDonThuId };
      }
      if (this.state.detail.donSTCD.chiTietLinhVucDonThuChiTietDon) {
        params.chiTietLinhVucDonThuChiTiet = { id: this.state.detail.donSTCD.chiTietLinhVucDonThuChiTietDon.linhVucDonThuId };
      } else {
        params.chiTietLinhVucDonThuChiTiet = null;
      }

      if (this.state.detail.donSTCD.coThongTinCoQuanDaGiaiQuyet) {
        params.coQuanDaGiaiQuyetDonThu = this.state.detail.donSTCD.coQuanDaGiaiQuyetDonThu;
        params.soVanBanDaGiaiQuyet = this.state.detail.donSTCD.soVanBanDaGiaiQuyet;
        params.ngayBanHanhVanBanDaGiaiQuyet = this.state.detail.donSTCD.ngayBanHanhVanBanDaGiaiQuyet ? moment(new Date(this.state.detail.donSTCD.ngayBanHanhVanBanDaGiaiQuyet), 'DD/MM/YYYY').add(7, 'hours').toISOString() : '';
      }

      Reception.actions.updateDon.request({ id: this.state.detail.donSTCD.donId }, params).then(res => {
        if (res.data) {
          browserHistory.push('/tiep-cong-dan');
          Toastr(msg.chuyenXLDSucess, 'success');
        }
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        this.setState({ loadingSave: false });
      });
    }
  }

  handleRemove(index, name) {
    this.state[name].splice(index, 1);
    this.setState({ [name]: this.state[name] });
  }

  handleChangeEditableTLBS(index, name, value) {
    this.state.dsTaiLieuBoSung[index][name] = value;
    this.setState({ dsTaiLieuBoSung: this.state.dsTaiLieuBoSung });
  }
  handleChangeSelectTLBS(index, e) {
    this.state.dsTaiLieuBoSung[index][e.target.name] = e.target.value;
    this.setState({ dsTaiLieuBoSung: this.state.dsTaiLieuBoSung });
  }
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
      <div id="page" className="panel-page">
        <div className="center">
          <div className="back-foward">
            <Link onClick={browserHistory.goBack} title="" >Về trang trước</Link>
          </div>
          <div className="heading">
            <h2 className="heading-title icon-detail">Thông tin chi tiết đơn thư/vụ việc</h2>
          </div>
          {/*heading*/}
          <div className="main_page">
            <div className="wrapper_box">
              <div className="page-wrapper mt0">
                <div className="box-items no-border">
                  <div className="rows">
                    <TextMessage className="col-6" labelClass="pt-inline" label="Ngày tiếp:" value={this.state.ngayTiepNhan} />
                    <div className="col-6">
                      <p className="pull-right reception-count">Lượt tiếp <span>{this.state.TongLuotTiep}</span></p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="page-wrapper">
                <ThongTinNguoiDungDon
                  title="Thông tin người đứng đơn/Vụ việc"
                  parent={this.state}
                />
              </div>
              {this.state.data.coUyQuyen ? (
                <div className="page-wrapper">
                  <div className="box-items no-border">
                    <ThongTinNguoiUyQuyen
                      title="Thông tin người được ủy quyền"
                      parent={this.state}
                    />
                  </div>
                </div>
              ) : ''}
              <div className="page-wrapper">
                <div className="box-items no-border">
                  <ThongTinDonVuViec
                    title="Thông tin đơn/Vụ việc"
                    isOpen = {true}
                    parent = {this.state}
                  />
                </div>
              </div>
              <ShowIf condition={this.state.data.coThongTinCoQuanDaGiaiQuyet == true} >
                <div className="page-wrapper">
                  <div className="box-items no-border">
                    <ThongTinCoQuanDaGiaiQuyet
                      title="Thông tin cơ quan đã giải quyết"
                      isOpen={true}
                      parent={this.state}
                    />
                  </div>
                </div>
              </ShowIf>
              <div className="page-wrapper">
                <div className="box-items">
                  <div className="box-forward">

                      <div className="group-box">
                        <div className="title">
                          <div className="rows">
                            <div className="col-12">
                              <h3>Thông tin xử lý lượt tiếp công dân</h3>
                            </div>
                          </div>
                        </div>
                        <div className="items-form mb10">
                          <div className="rows">
                            <TextMessage className="col-12" label="Hướng xử lý:" value={this.state.detail.huongXuLyText} />
                          </div>
                        </div>
                        <div className="items-form">
                          <div className="rows">
                            <TextMessage className="col-12" label={this.state.HuongXuLy == 'TRA_DON_VA_HUONG_DAN' ? 'Nội dung hướng dẫn:' : (this.state.HuongXuLy == 'TU_CHOI' ? 'Lý do từ chối:' : (this.state.HuongXuLy == 'BO_SUNG_THONG_TIN' ? 'Nội dung bổ sung:' : 'Ghi chú:'))} value={this.state.GhiChuXuLy}/>
                          </div>
                        </div>
                      </div>

                  </div>
                </div>
              </div>
              {
                this.state.HuongXuLy == 'BO_SUNG_THONG_TIN' ?
                  <div className="page-wrapper">
                    <div className="box-items mb0-18">
                      <div className="box-forward">

                          <div className="group-box">
                            <div className="title">
                              <div className="rows">
                                <div className="col-12">
                                  <h3>Tài liệu bổ sung</h3>
                                </div>
                              </div>
                            </div>
                            <div className="items-form">
                              <div className="rows">
                                <div className="col-12">
                                  <DataTable
                                    header={header.detailReception.proof}
                                    dataList={this.state.detail.taiLieuBangChungBoSungs}
                                    hidePagination={true}
                                    hideExport={true}
                                    parent={this}
                                    tableLoading={this.state.tableLoading}>
                                    <RowItemDocumentDetail/>
                                  </DataTable>
                                </div>
                              </div>
                            </div>
                          </div>

                      </div>
                    </div>
                  </div>
                : ''
              }
              <TinhTrangDon data = {this.state.data}/>
            </div>
            <div className="box-bottom">
              <Link className="btn-action btn-close" to={'/tiep-cong-dan'}>
                <span>Đóng</span>
              </Link>
              {
                CheckPermission('SOTIEPCONGDAN_SUA') && !this.state.detail.donSTCD.thanhLapTiepDanGapLanhDao && !this.state.detail.hoanThanhTCDThuongXuyen && this.state.detail.donSTCD.tongSoLuotTCD == this.state.detail.soThuTuLuotTiep && this.state.detail.donSTCD.trangThaiYeuCauGapLanhDao != 'DONG_Y' && this.state.detail.donSTCD.trangThaiYeuCauGapLanhDao != 'KHONG_DONG_Y' && !this.state.detail.donSTCD.hoanThanhDon && !this.state.detail.donSTCD.lanhDaoDuyet && this.state.detail.nguoiTaoId === this.props.userInfo.id ?
                  <Link className="btn-action btn-edit" to={`/tiep-cong-dan/thuong-xuyen/chinh-sua/${this.state.idSoTiepCongDan}`}>
                    <span>Sửa</span>
                  </Link>
                : null
              }
              {
                (CheckPermission('SOTIEPCONGDAN_SUA') &&
                this.state.detail &&
                this.props.userInfo &&
                this.state.detail.donSTCD &&
                this.state.detail.nguoiTaoId === this.props.userInfo.id &&
                !this.state.detail.donSTCD.thanhLapDon && !this.state.detail.donSTCD.thanhLapTiepDanGapLanhDao &&
                !this.state.detail.hoanThanhTCDThuongXuyen &&
                this.state.detail.huongXuLy == 'TIEP_NHAN_DON' &&
                this.state.detail.donSTCD.tongSoLuotTCD == this.state.detail.soThuTuLuotTiep) &&
                  <Link className={`btn-action btn-move ${this.state.loadingSave ? 'btn-loading-inline' : ''}`} onClick={this.updateDon.bind(this)}>
                    <span>Chuyển xử lý đơn</span>
                  </Link>
              }
            </div>
          </div>
          {/*main_page*/}
        </div>
      </div>
      </MasterLayout>
    );
  }
}
DetailReception.defaultProps = {
  loaiDonThu: [],
  loaiDoiTuong: [],
}

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    loaiDonThu: state.duLieuHeThong.loaiDonThu,
    loaiDoiTuong: state.duLieuHeThong.loaiDoiTuong,
  };
}

export default connect(bindStateToProps)(DetailReception);



// WEBPACK FOOTER //
// ./src/components/modules/reception/detail-reception/DetailReception.jsx